import * as React from "react";
import "flag-icon-css/css/flag-icon.css";

export const Flag = React.memo<{ country: string }>(({ country }) => {
  return <span className={`flag-icon flag-icon-${country.toLowerCase()}`} />;
});
